import switchboard from './lib/switchboard';
import TrackingEvents from './lib/enums/events';
import MessageService from 'message-service/message-service';

export default {
    track: switchboard,
    setProps: switchboard.setProps,
    setData: switchboard.setData,
    getData: switchboard.getData,
    init: switchboard.init,
    GD5MessageService: MessageService,
    GD5TrackingEvents: TrackingEvents
};